// React
import React from 'react';

import HomeLinkButton from '../../components/HomeLinkButton';

// Style
import './style.sass';

const HomeButtonSeparator = ({ t, href }) => {
  return (
    <div className="home-button-separator-wrapper">
      <p className="home-button-separator-title">
        {t('c1do1Black.home.separator.title')}
      </p>
      <HomeLinkButton t={t} href={href} />
    </div>
  );
};

export default HomeButtonSeparator;
